import { h } from 'preact';
import styles from './ArticleCard.module.scss';
export function ArticleCard({ article }) {
    const excerpt = article.summary_html || article.body_html;
    const cleanExcerpt = excerpt
        ? excerpt.replace(/<[^>]*>/g, '').substring(0, 200) + '...'
        : '';
    const formatDate = (dateString) => {
        if (!dateString)
            return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };
    return (h("a", { href: article.url, class: styles.articleCard },
        article.image && (h("div", { class: styles.articleImage },
            h("img", { src: article.image.src, alt: article.image.alt || article.title }))),
        h("div", { class: styles.articleContent },
            h("span", { class: styles.articleTitle }, article.title),
            (article.author || article.published_at) && (h("div", { class: styles.articleMeta },
                article.author && h("span", { class: styles.author },
                    "By ",
                    article.author),
                article.published_at && (h("span", { class: styles.date }, formatDate(article.published_at))))),
            cleanExcerpt && h("p", { class: styles.articleExcerpt }, cleanExcerpt),
            h("span", { class: styles.readMore }, "Read Article \u2192"))));
}
